import React, { useEffect, useState, useMemo } from "react";
import { faMapMarkerAlt, faStore, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./ShoppingBasket.module.css";
import ShoppingList from "../ShoppingList/ShoppingList";
import AddNote from "../AddNote/AddNote";
import { UpdateProductCountInBasket } from "../../Api/BarestServices";
import { errorToast, succToast } from "../../Toast/Toast";
import { DeletebasketApi } from "../../Api/ClientServices";
import { separate } from "../../Seprate/Seprate";
import Swal from "sweetalert2";

const ShoppingBasket = ({ data, supID, sendDescription, rerenderForce, finalize }) => {
  const [textNote, setTextNote] = useState(data?.description || "");
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    setTextNote(data?.description || "");
  }, [data?.description]);

  // Handle note submission when finalizing
  useEffect(() => {
    if (sendDescription && data?.supplier_id) {
      const desc = {
        supplier_id: data.supplier_id,
        description: textNote,
      };

      UpdateProductCountInBasket(desc, (res) => {
        if (res.status !== 1) {
          errorToast(res.message);
        }
      });
      const timer = setTimeout(() => finalize && finalize(), 500);
      return () => clearTimeout(timer);
    }
  }, [sendDescription, data?.supplier_id, textNote, finalize]);

  const totalPrice = useMemo(() => {
    if (!Array.isArray(data?.products)) return 0;
    return data.products.reduce((sum, item) => {
      const price = parseInt(item.off_price > 0 ? item.off_price : item.price || 0, 10);
      const count = parseInt(item.count || 1, 10);
      return sum + price * count;
    }, 0);
  }, [data?.products]);

  const totalCount = useMemo(() => {
    if (!Array.isArray(data?.products)) return 0;
    return data.products.reduce((sum, item) => sum + parseInt(item.count || 1, 10), 0);
  }, [data?.products]);

  const deleteHandler = (id) => {
    Swal.fire({
      title: "حذف سبد خرید؟",
      text: `آیا از حذف سبد خرید «${data?.name || "این فروشگاه"}» اطمینان دارید؟`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#c20c64",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "بله، حذف کن",
      cancelButtonText: "انصراف",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-toast",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setDisable(true);
        DeletebasketApi({ supplier_id: id }, (suc, res) => {
          setDisable(false);
          if (!suc) {
            errorToast(res?.message || "خطا در حذف سبد");
          } else {
            succToast("سبد خرید با موفقیت حذف شد");
            if (rerenderForce) rerenderForce();
          }
        });
      }
    });
  };

  if (!data) return null;

  return (
    <div className={Style.BasketHolder}>
      <div className={Style.cardContainer}>
        {/* Card Header: Supplier Details & Delete Action */}
        <div className={Style.headerSection}>
          <div className={Style.supplierInfo}>
            <div className={Style.logoWrapper}>
              <img
                src={`//cdn.barest.ir/supplier/logo/${data.logo}.jpg`}
                alt={data.name || "فروشگاه"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/Assets/Images/Order/not2.png";
                }}
              />
            </div>
            <div className={Style.titleAndAddress}>
              <h3 className={Style.supplierName}>
                <FontAwesomeIcon icon={faStore} className={Style.storeIcon} />
                {data.name}
              </h3>
              {data.address && (
                <p className={Style.supplierAddress}>
                  <FontAwesomeIcon icon={faMapMarkerAlt} className={Style.markerIcon} />
                  <span>{data.address}</span>
                </p>
              )}
            </div>
          </div>

          <button
            type="button"
            className={Style.deleteButton}
            onClick={() => deleteHandler(supID || data.supplier_id)}
            disabled={disable}
            title="حذف این سبد خرید"
          >
            <FontAwesomeIcon icon={faTrashAlt} />
            <span className={Style.deleteText}>حذف سبد</span>
          </button>
        </div>

        {/* Products List */}
        <div className={Style.itemsSection}>
          <div className={Style.itemsSectionHeader}>
            <span>اقلام سفارش</span>
            <span className={Style.itemsBadge}>
              {data.products?.length || 0} قلم ({totalCount} عدد)
            </span>
          </div>

          <ul className={Style.productsList}>
            {data.products?.map((item) => (
              <ShoppingList
                supplierId={data.supplier_id}
                List={item}
                key={item.id}
                onclickforce={rerenderForce}
              />
            ))}
          </ul>
        </div>

        {/* Note / Description */}
        <div className={Style.noteSection}>
          <AddNote userNote={textNote} Textfunction={setTextNote} />
        </div>

        {/* Summary Footer */}
        <div className={Style.summaryFooter}>
          <div className={Style.priceRow}>
            <span className={Style.priceLabel}>مجموع فاکتور فروشگاه:</span>
            <div className={Style.priceValue}>
              <strong>{separate(totalPrice)}</strong>
              <small>تومان</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingBasket;
